/** @jsxImportSource @emotion/react */
import { css, Global } from '@emotion/react'
import { Divider, Header } from 'semantic-ui-react'

const SectionHeader = ({ title }) => {
    return (
      <>
          <Global styles={css`
              .dashboard-section-header ~ .dashboard-section-header {
                  margin-top: 2.5rem;
              }
          `}/>
          <Divider horizontal className="dashboard-section-header">
              <Header as="h4">
                  {title}
              </Header>
          </Divider>
      </>
    )
}

export { SectionHeader }
